import React, { useEffect, useState } from "react";


import styled from "@emotion/styled";
import { Container } from "@mui/material";

import MenuPSM from "./MenuPSM";

import HeaderImage from "../../../images/bg.png";
import teardownforHeader from "../../../images/teardownforHeader.png";
import HeaderMobImage from "../../../images/bgmobile.png";
import logowhite from "../../../images/logowhite.png";
import Tiktok from "../../../images/TikTok.png";
import Instagram from "../../../images/instagram.png";
import Twitter from "../../../images/twitter.png";
import Facebook from "../../../images/fb.png";
import Imdb from "../../../images/imdb.png";
import { BASEURL } from "../../../configure";
import { Content } from "../../../styles";

const TearDownRelative = styled.div`
  position: relative;
`;
const TearDown = styled.div`
  width: 100%;
  position: absolute;
  bottom: -15px;
  // z-index: 1;
  @media screen and (max-width: 899px) {
    // display: none;
  }
`;
const MainWrapper = styled.div`
  background-image: url(${props=>props.bg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @media screen and (max-width: 599px) {
    background-image: url(${HeaderMobImage});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
`;
const Wrapper = styled.div`
  min-height: 92vh;
  position: relative;
  display: flex;
  place-items: center;
  max-width: 1536px;
  margin: auto;
  @media screen and (min-width: 1920px) and (min-height: 1200px) {
    min-height: 94vh;
  }
`;
const SocialMedia = styled.div`
  z-index: 2;
  display: inline-grid;
  position: absolute;
  right: 50px;
  top: 100px;
  @media screen and (max-width: 599px) {
    right: 20px;
  }
`;
const SocialMediaLinks = styled.a`
  z-index: 2;
  mix-blend-mode: lighten;
  padding-top: 15px;
  opacity: 0.7;
`;
const Downarrow = styled.a`
  position: absolute;
  right: 0;
  left: 0;
  bottom: 50px;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 599px) {
    display: none;
  }
`;
const SectionHeading = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  place-content: center;
  z-index: 1;
  @media screen and (max-width: 599px) {
    top: 100%;
    transform: translate(-50%, -100%);
  }
`;

const Slidedown = styled.a``;
const MainLogo = styled.img`
  width: 100%;
  height: auto;
  max-width: 700px;
`;
const SocialMediaImages = styled.img`
  width: 100%;
  height: auto;
  max-width: 32px;
`;
const Index = () => {
  const [ getTiktok, setTiktok ] = useState('');
  const [ getInsta, setInsta ] = useState('');
  const [ getTwitter, setTwitter ] = useState('');
  const [ getFacebook, setFacebook ] = useState('');
  const [ getImdb, setImdb ] = useState('');

  const [ getHeaderImg, setHeaderImg ] = useState('');
  const [ getContent, setContent ] = useState('');

  
  let getSectionContent = async () => {
    let projects = await fetch(BASEURL+'section/88?&_embed', {
      method: 'GET',
    })
    const data = await projects.json();
    setHeaderImg(data?._embedded?.['wp:featuredmedia'][0]['source_url'])
    setContent(data?.content?.rendered)
    
  }

  useEffect(()=>{
    getSectionContent();
      fetch(BASEURL+'social', {
        method: 'GET',
      }).then(response => response.json())
      .then( jsonData => {
        setTiktok(jsonData[0]?.tiktok)
        setInsta(jsonData[0]?.insta)
        setTwitter(jsonData[0]?.twitter)
        setFacebook(jsonData[0]?.facebook)
        setImdb(jsonData[0]?.imdb)
      }) 
  },[getTiktok, getTwitter, getImdb])
  return (
    <div>
      <Slidedown href="/#primary">
        <SectionHeading>
          {/* <MainLogo src={logowhite} /> */}
          <Content dangerouslySetInnerHTML={{__html: `${getContent}`}} />
        </SectionHeading>
      </Slidedown>
      <div data-aos="fade-in" data-aos-duration="1600" data-aos-easing="ease-in-out" data-aos-delay="3000" data-aos-offset="0" >
        <MainWrapper bg={getHeaderImg}>
          <MenuPSM />
          <Wrapper>
            <SocialMedia>
            { getTiktok? 
              <SocialMediaLinks href={getTiktok? getTiktok: `#`} target="_blank">
                <SocialMediaImages src={Tiktok} />
              </SocialMediaLinks>
            : null}
            { getInsta? 
              <SocialMediaLinks href={getInsta? getInsta: `#`} target="_blank">
                <SocialMediaImages src={Instagram} />
              </SocialMediaLinks>
            : null}
            { getTwitter? 
              <SocialMediaLinks href={getTwitter? getTwitter: `#`} target="_blank">
                <SocialMediaImages src={Twitter} />
              </SocialMediaLinks>
            : null}
            { getFacebook? 
              <SocialMediaLinks href={getFacebook? getFacebook: `#`} target="_blank">
                <SocialMediaImages src={Facebook} />
              </SocialMediaLinks>
            : null}
            { getImdb? 
              <SocialMediaLinks href={getImdb? getImdb: `#`} target="_blank">
                <SocialMediaImages src={Imdb} />
              </SocialMediaLinks>
            : null}
            </SocialMedia>
          </Wrapper>
        </MainWrapper>
        <TearDownRelative>
          <TearDown>
            <img src={teardownforHeader} style={{ width: "100%", height: "auto" }} layout="intrinsic" />
          </TearDown>
        </TearDownRelative>
      </div>
    </div>
  );
};

export default Index;
